<template>
    <app-content>
        <form action="#">
            <div class="inner">
                <p class="buttons">
                    <app-button-delete @click="deleteItem" v-if="!newItem"/>
                </p>
                <app-content-title v-if="!newItem && !pending"
                                   :title="item.name"/>
                <app-content-title v-if="newItem" :title="translations.newPackage"/>
            </div>
            <app-tabs
                :colsTabs="columnTabs"
                :shouldLoadFirstTab="newItem"
                :loadTab="params.tab"
                @appTabChanged="onAppTabChanged"
            >
            <div :title="translations.information">
                <app-settings @submit="onFormSubmit" :disabled="pending">
                    <app-settings-content>
                        <app-settings-desc :title="translations.basicInfo">
                            <p v-if="!newItem">
                                <translate>Založeno</translate>
                                :<br/>
                                <span v-html="formatDateAdvanced(item._created)"/>
                            </p>
                            <p v-if="!newItem">
                                <translate>Upraveno</translate>
                                :<br/>
                                <span v-html="formatDateAdvanced(item._updated)"/>
                            </p>
                        </app-settings-desc>

                        <app-settings-options>
                            <app-settings-col class="field_left">
                                <app-input
                                    :label="translations.name"
                                    required
                                    :error="errors.items.find(el => el.field === 'name')"
                                    v-model="formItem.name"
                                    name="name"

                                />

                                <app-input
                                    :label="translations.age"
                                    required
                                    :error="errors.items.find(el => el.field === 'age')"
                                    v-model="formItem.age"
                                    name="age"
                                    type="number"
                                />
                            </app-settings-col>

                            <app-settings-col class="field_right">
                                <app-settings-control class="checkbox">
                                    <app-checkbox
                                        name="isDefault"
                                        :title="translations.isDefault"
                                        :error="!!errors.first('isDefault')"
                                        v-model="formItem.isDefault"
                                    />
                                </app-settings-control>

                                <app-settings-control class="checkbox">
                                    <app-checkbox
                                        name="isChildDefault"
                                        :title="translations.isChildDefault"
                                        :error="!!errors.first('isChildDefault')"
                                        v-model="formItem.isChildDefault"
                                    />
                                </app-settings-control>
                            </app-settings-col>
                        </app-settings-options>
                    </app-settings-content>

                    <app-settings-buttons :navLinkTitle="translations.list" :nav-link-to="{ name: 'maturityRatings' }">
                        <app-content-save-button :disabled="pending" @click="disallowBack"/>
                    </app-settings-buttons>
                </app-settings>
            </div>
            <div :title="translations.tvStations + ' (' + (item && item._tvStations ? item._tvStations.length : 0) + ')'"
                 :data-disabled-title="translations.tvStationsSaveFirst"
                 :data-disabled="!item || !item._id"
            >
                <maturity-rating-tv-stations :tvStations="item._tvStations" />
            </div>
            </app-tabs>
        </form>
    </app-content>
</template>

<script>
import getItemDetailMixin from 'mixins/getItemDetailMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import { getCommonFormSubmit } from 'utils/form'
import MaturityRatingTvStations from "@/components/MaturityRating/TvStations.vue";

const itemDetailMixin = getItemDetailMixin({
  apiMethodsSuffix: 'MaturityRating',
  parentRouteName: 'maturityRatings',
  storeModuleName: 'maturityRatings',
  storeItemName: 'maturityRating',
})

export default {
  name: 'maturity-rating-item',
  components: {MaturityRatingTvStations},
  mixins: [formatDateMixin, itemDetailMixin, appTitleMixin()],
  data() {
    return {
      columnTabs: [0, 1],
    }
  },
    methods: {
    async onFormSubmit(e) {
      this.errors.clear()

      this.formErrors = await this.runValidation()
      if (this.formErrors.items.length > 0) {
        this.appShowErrors(this.formErrors.items.map(v => v.msg))
        return
      }

      const commonFormSubmit = getCommonFormSubmit('MaturityRating')
      const response = await commonFormSubmit(this, e).catch(err => err.response)

      this.handleResponseIfError(response)

      if (!this.backAllowed && response.status === 201) {
        this.goToDetail(response.data.data._id)
      }
    },
    async runValidation() {
      await this.errors.clear()
      await this.$validator.validateAll()
      return this.errors
    },
  },
  computed: {
    translations() {
      return {
        information: this.$gettext('Informace'),
        newMaturityRating: this.$gettext('Nová věková hranice'),
        name: this.$gettext('Název'),
        age: this.$gettext('Věk'),
        basicInfo: this.$gettext('Základní údaje'),
        list: this.$gettext('Seznam'),
        tvStations: this.$gettext('TV Stanice'),
        tvStationsSaveFirst: this.$gettext('TV Stanice'),
        isDefault: this.$gettext('Výchozí hranice'),
        isChildDefault: this.$gettext('Výchozí dětská hranice')
      }
    },
    currentTitle() {
      return [
        { name: this.$gettext('Věkové hranice'), link: { name: 'maturityRatings' } },
          this.item.name || this.translations.newMaturityRating
      ]
    },
  },
}
</script>
